function catchAndThrow(fn, error){
  try {
    fn();
  } catch (e) {
    throw new Error(error);
  }

}

export default catchAndThrow;



// WEBPACK FOOTER //
// ./client/app/common/errors/error.utils.js